/**
 * Lógica de Dropdown Dependiente para Agencias Shalom vía n8n (Integración Releasit)
 * Detecta cambios en Ciudad para poblar sedes.
 * Aplica Lógica Condicional: Oculta la selección de Agencia si la Provincia es Lima o vacía.
 */

document.addEventListener('DOMContentLoaded', () => {
    let initializedTriggers = new Set();
    let initializedProvinceTriggers = new Set();
    let targetSelectElement = null;
    let targetWrapperElement = null; // El contenedor de UI para los radios de Agencia
    let dropdownWrapperElement = null; // El contenedor del select Oficina Shalom
    let addressWrapperElement = null; // El contenedor de UI para Dirección
    let imageWrapperElement = null; // El contenedor de UI para la imagen
    let imageImgElement = null; // El elemento img en sí

    // Buscador en profundidad para element
    function querySelectorDeep(selector) {
        let el = document.querySelector(selector);
        if (el) return el;
        const elements = document.querySelectorAll('*');
        for (let i = 0; i < elements.length; i++) {
            if (elements[i].shadowRoot) {
                el = elements[i].shadowRoot.querySelector(selector);
                if (el) return el;
            }
        }
        return null;
    }

    // Escuchamos cambios de los radios nativamente
    document.addEventListener('change', (e) => {
        if (e.target && e.target.type === 'radio' && targetWrapperElement && targetWrapperElement.contains(e.target)) {
            toggleShalomDropdownVisibility();
            refetchIfCitySelected();
        }
    });

    function getSelectedAgency() {
        if (!targetWrapperElement) return '';
        const radios = targetWrapperElement.querySelectorAll('input[type="radio"]');
        for (let r of radios) {
            if (r.checked) {
                if (r.value.toLowerCase().includes('olva')) return 'olva';
                if (r.value.toLowerCase().includes('shalom')) return 'shalom';
            }
        }
        return '';
    }

    function refetchIfCitySelected() {
        if (!targetSelectElement || !dropdownWrapperElement || dropdownWrapperElement.style.display === 'none') return;
        
        let citySelected = "";
        const selects = document.querySelectorAll('select');
        selects.forEach(s => {
            const name = (s.name || '').toLowerCase();
            const id = (s.id || '').toLowerCase();
            if (name.includes('city') || id.includes('city') || getLabelText(s).toLowerCase().includes('ciudad')) {
                const val = s.options[s.selectedIndex]?.text || s.value;
                if (val && !val.toLowerCase().includes('selecciona')) {
                    citySelected = val;
                }
            }
        });
        
        // Limpiamos siempre que cambie la agencia
        targetSelectElement.innerHTML = '';
        const opt = document.createElement('option');
        opt.value = "";
        opt.textContent = "Actualizando sedes...";
        targetSelectElement.appendChild(opt);
        
        if (citySelected) {
            fetchSedes(citySelected);
        } else {
            const agency = getSelectedAgency();
            opt.textContent = agency === 'olva' ? "A la espera de ciudad (Olva)..." : "A la espera de ciudad (Shalom)...";
        }
    }

    // Función para buscar recursivamente elementos select incluso dentro de Shadow DOM
    function getAllSelects(root) {
        let allSelects = Array.from(root.querySelectorAll('select'));
        const elements = root.querySelectorAll('*');
        elements.forEach(el => {
            if (el.shadowRoot) {
                allSelects = allSelects.concat(getAllSelects(el.shadowRoot));
            }
        });
        return allSelects;
    }

    // Identificador principal
    function findElements() {
        const selects = getAllSelects(document);
        
        let cityTriggers = []; 
        let provinceTriggers = [];
        let target = null;

        selects.forEach(select => {
            const id = (select.id || '').toLowerCase();
            const name = (select.name || '').toLowerCase();
            const labelText = getLabelText(select).toLowerCase();

            // Detectar si es el desplegable OBJETIVO (Agencia Shalom)
            if (id.includes('additionals_dropdown_input') || name.includes('additionals_dropdown')) {
                if (labelText.includes('shalom') || labelText.includes('nombre del campo') || id.includes('additionals')) {
                    target = select;
                }
            }
            // Detectar si es el desplegable DISPARADOR DE CIUDAD (pobla datos)
            if (name.includes('city') || id.includes('city') || labelText.includes('ciudad')) {
                cityTriggers.push(select);
            }

            // Detectar si es el desplegable INTERRUPTOR DE VISIBILIDAD (Provincia)
            if (name.includes('province') || id.includes('province') || labelText.includes('provincia')) {
                provinceTriggers.push(select);
            }
        });

        targetSelectElement = target;
        
        // Identificando el contenedor del dropdown "Oficina Shalom"
        if (targetSelectElement) {
            let wrp = targetSelectElement.closest('.rsi-select-wrapper') || targetSelectElement.parentElement.parentElement;
            if (wrp && wrp.parentElement && wrp.parentElement.style.gridColumn) {
                dropdownWrapperElement = wrp.parentElement;
            } else {
                dropdownWrapperElement = wrp;
            }
        }
        
        // Ahora buscamos el contenedor de los Radio Buttons "Agencia" para ocultarlo
        let agencyRadioWrapper = null;
        let allLabels = Array.from(document.querySelectorAll('label'));
        // Check shadow dom too if needed
        const elements = document.querySelectorAll('*');
        elements.forEach(el => {
            if (el.shadowRoot) {
                allLabels = allLabels.concat(Array.from(el.shadowRoot.querySelectorAll('label')));
            }
        });
        
        allLabels.forEach(label => {
            if (label.textContent.trim().toLowerCase() === 'agencia') {
                agencyRadioWrapper = label.closest('.rsi-radio-wrapper') || label.parentElement.parentElement;
            }
        });

        // Identificando el contenedor entero visual para ocultarlo en bloque (El Radio de Agencia)
        if (agencyRadioWrapper) {
            // Ocultar también la celda del grid si existe para no dejar huecos
            if (agencyRadioWrapper.parentElement && agencyRadioWrapper.parentElement.style.gridColumn) {
                targetWrapperElement = agencyRadioWrapper.parentElement;
            } else {
                targetWrapperElement = agencyRadioWrapper;
            }
        }

        // Buscar contenedor de Dirección
        const addressInputDOM = querySelectorDeep('#address, input[name="address"]');
        if (addressInputDOM) {
            let wrp = addressInputDOM.closest('.rsi-text-input-wrapper') || addressInputDOM.parentElement.parentElement;
            if (wrp && wrp.parentElement && wrp.parentElement.style.gridColumn) {
                addressWrapperElement = wrp.parentElement;
            } else {
                addressWrapperElement = wrp;
            }
        }

        // Buscar imagen de Shalom/Olva
        const imgNode = querySelectorDeep('img[src*="shalom.png"], img[src*="OLVA.png"], img[src*="olva.png"], img[src*="Shalom.png"], img[src*="shalom"], img[src*="OLVA"]');
        if (imgNode) {
            imageImgElement = imgNode;
            let wrp = imgNode.closest('.rsi-image-item-wrapper') || imgNode.parentElement;
            if (wrp && wrp.parentElement && wrp.parentElement.style.gridColumn) {
                imageWrapperElement = wrp.parentElement;
            } else {
                imageWrapperElement = wrp;
            }
        }



        // Si tenemos el contenedor asignado, corremos la validación inicial de una vez
        // Buscamos cuál es el estado actual de la provincia
        if (targetWrapperElement && provinceTriggers.length > 0) {
            const pVal = provinceTriggers[0].options[provinceTriggers[0].selectedIndex]?.text || provinceTriggers[0].value;
            toggleAgencyVisibility(pVal);
        } else if (targetWrapperElement) {
            // Si por alguna razón la provincia aún no ha cargado, ocultar por defecto
            toggleAgencyVisibility('');
        }

        // Asegurar que el select dependiente también arranca en su estado correcto
        toggleShalomDropdownVisibility();

        cityTriggers.forEach(trigger => {
            if (!initializedTriggers.has(trigger)) {
                initCityTrigger(trigger);
                initializedTriggers.add(trigger);
            }
        });

        provinceTriggers.forEach(trigger => {
            if (!initializedProvinceTriggers.has(trigger)) {
                initProvinceTrigger(trigger);
                initializedProvinceTriggers.add(trigger);
            }
        });
    }

    // Auxiliar para extraer el texto del label
    function getLabelText(element) {
        if (element.getAttribute('aria-label')) return element.getAttribute('aria-label');
        if (element.id) {
            const rootNode = element.getRootNode();
            const label = rootNode.querySelector(`label[for="${element.id}"]`);
            if (label) return label.textContent;
        }
        if (element.parentElement && element.parentElement.tagName === 'LABEL') {
            return element.parentElement.textContent;
        }
        return '';
    }

    function initCityTrigger(triggerElement) {
        triggerElement.addEventListener('change', (e) => {
            const queryName = e.target.options[e.target.selectedIndex]?.text || e.target.value;
            // Evitar búsquedas vacías o placeholders
            if (queryName && queryName.trim() !== '' && !queryName.toLowerCase().includes('selecciona')) {
                fetchSedes(queryName);
            } else {
                limpiarOpcionesBase();
            }
        });
    }

    function initProvinceTrigger(triggerElement) {
        triggerElement.addEventListener('change', (e) => {
            const queryName = e.target.options[e.target.selectedIndex]?.text || e.target.value;
            toggleAgencyVisibility(queryName);
        });
    }

    function toggleAgencyVisibility(provinciaValue) {
        if (!targetWrapperElement) return;

        const valLower = (provinciaValue || '').toLowerCase();
        
        // Por defecto oculto: vacío, placeholder "Provincia"/"Selecciona", Lima o Callao
        if (!valLower || valLower === 'provincia' || valLower.includes('selecciona') || valLower.includes('lima') || valLower.includes('callao')) {
            if (targetWrapperElement) targetWrapperElement.style.display = 'none';
            
            // Si hay UI de 'Agencia', la deseleccionamos
            if (targetWrapperElement) {
                const radios = targetWrapperElement.querySelectorAll('input[type="radio"]');
                let changed = false;
                radios.forEach(radio => {
                    if (radio.checked) {
                        radio.checked = false;
                        changed = true;
                    }
                });
                if (changed && radios.length > 0) {
                    radios[0].dispatchEvent(new Event('change', { bubbles: true }));
                }
            }

            // Reseteo del select "Oficina Shalom" (sólo si no está ya vacío para evitar loop infinito)
            if (targetSelectElement) {
                const isAlreadyEmpty = targetSelectElement.options.length > 0 && targetSelectElement.options[0].textContent === "A la espera de ciudad...";
                if (!isAlreadyEmpty) {
                    targetSelectElement.innerHTML = '';
                    const placeholderOption = document.createElement('option');
                    placeholderOption.value = "";
                    placeholderOption.textContent = "A la espera de ciudad...";
                    targetSelectElement.appendChild(placeholderOption);

                    const nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLSelectElement.prototype, "value").set;
                    if (nativeInputValueSetter) {
                        nativeInputValueSetter.call(targetSelectElement, "");
                    }
                    targetSelectElement.dispatchEvent(new Event('change', { bubbles: true }));
                }
            }
        } else {
            // Se muestra normal (restablece display default de React/CSS)
            if (targetWrapperElement) {
                targetWrapperElement.style.display = 'block'; 
                if (targetWrapperElement.classList.contains('rsi-radio-wrapper') || targetWrapperElement.firstElementChild?.classList.contains('rsi-radio-wrapper')) {
                    targetWrapperElement.style.display = 'flex';
                    if (targetWrapperElement.classList.contains('rsi-radio-wrapper')) {
                        targetWrapperElement.style.flexDirection = 'column';
                    }
                }
            }
        }

        // --- Lógica exclusiva para Dirección ---
        // Oculto por defecto a menos que sea Lima (o vacio/selecciona no deberia mostrarse)
        if (addressWrapperElement) {
            if (valLower.includes('lima')) {
                // Se activa si seleccionan Lima
                addressWrapperElement.style.display = 'block';
                if (addressWrapperElement.classList.contains('rsi-text-input-wrapper') || addressWrapperElement.firstElementChild?.classList.contains('rsi-text-input-wrapper')) {
                    addressWrapperElement.style.display = 'flex';
                    if (addressWrapperElement.classList.contains('rsi-text-input-wrapper')) {
                        addressWrapperElement.style.flexDirection = 'column';
                    }
                }
            } else {
                // Se oculta si es Provincia u otra cosa vacía
                addressWrapperElement.style.display = 'none';
            }
        }

        // Al finalizar de procesar Agencia, ajustamos la visibilidad de Oficina Shalom
        toggleShalomDropdownVisibility();
    }

    function toggleShalomDropdownVisibility() {
        if (!dropdownWrapperElement || !targetWrapperElement) return;

        // Para mostrar, debe estar visible la "Agencia" Y estar marcada la opción "Shalom" u "Olva"
        const isRadioVisible = targetWrapperElement.style.display !== 'none';
        const agencyName = getSelectedAgency();
        const isShowable = (agencyName === 'shalom' || agencyName === 'olva');

        if (isRadioVisible && isShowable) {
            dropdownWrapperElement.style.display = 'block'; 
            if (dropdownWrapperElement.classList.contains('rsi-select-wrapper') || dropdownWrapperElement.firstElementChild?.classList.contains('rsi-select-wrapper')) {
                dropdownWrapperElement.style.display = 'flex';
                if (dropdownWrapperElement.classList.contains('rsi-select-wrapper')) {
                    dropdownWrapperElement.style.flexDirection = 'column';
                }
            }

            // ACTUALIZAR EL LABEL (título encima del desplegable)
            const label = dropdownWrapperElement.querySelector('label');
            if (label) {
                const reqSpan = label.querySelector('span') ? label.querySelector('span').outerHTML : '';
                
                // Evitamos reasignar innerHTML si ya tiene el texto correcto
                // para evitar caer en un loop infinito con el MutationObserver (childList: true)
                if (agencyName === 'shalom' && !label.textContent.includes('Oficina Shalom')) {
                    label.innerHTML = 'Oficina Shalom' + reqSpan;
                } else if (agencyName === 'olva' && !label.textContent.includes('Oficina Olva')) {
                    label.innerHTML = 'Oficina Olva' + reqSpan;
                }
            }
            
            // ACTUALIZAR IMAGEN VISIBLE
            if (imageWrapperElement && imageImgElement) {
                imageWrapperElement.style.display = 'block';
                if (agencyName === 'shalom') {
                    if (!imageImgElement.src.includes('shalom.png')) {
                        imageImgElement.src = 'https://cdn.shopify.com/s/files/1/0980/1649/3875/files/shalom.png?v=1774770839';
                    }
                } else if (agencyName === 'olva') {
                    if (!imageImgElement.src.includes('OLVA.png')) {
                        imageImgElement.src = 'https://cdn.shopify.com/s/files/1/0980/1649/3875/files/OLVA.png?v=1774770899';
                    }
                }
            }
            
        } else {
            dropdownWrapperElement.style.display = 'none';
            if (imageWrapperElement) {
                imageWrapperElement.style.display = 'none';
            }
        }
    }

    async function fetchSedes(query) {
        if (!targetSelectElement || targetWrapperElement?.style.display === 'none') return; // Si no hay objetivo o está oculto, no hace nada

        const agency = getSelectedAgency();
        let url = 'https://n8n.solucionesfym.com/webhook/buscar-sedes-v2'; // Shalom default
        if (agency === 'olva') {
            url = 'https://n8n.solucionesfym.com/webhook/buscar-sedes-olva-v2';
        }
        
        try {
            marcarCargando();

            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ query: query })
            });

            if (!response.ok) {
                throw new Error('Error en la API HTTP: ' + response.status);
            }

            const textResponse = await response.text();
            let data = [];
            if (textResponse && textResponse.trim() !== '') {
                try {
                    data = JSON.parse(textResponse);
                } catch (e) {
                    throw new Error('Formato JSON inválido desde n8n');
                }
            }
            
            // n8n envuelve la respuesta en un array: [{ results: [...] }]
            // Desenvolvemos ese wrapper para llegar a los datos reales
            let unwrapped = data;
            if (Array.isArray(data) && data.length === 1 && data[0] && data[0].results) {
                unwrapped = data[0];
            }
            const resolvableData = Array.isArray(unwrapped) ? unwrapped : (unwrapped.results || unwrapped.data || []);
            
            // Diagnóstico temporal - ver en consola del navegador (F12)
            console.log('[Shalom Debug] Raw response type:', typeof data, Array.isArray(data) ? '(array len=' + data.length + ')' : '');
            console.log('[Shalom Debug] Unwrapped:', unwrapped);
            console.log('[Shalom Debug] Final sedes count:', resolvableData.length, 'First:', resolvableData[0]);
            
            renderSedesDropdown(resolvableData);
            
        } catch (error) {
            console.error('Error al autocompletar sedes en desplegable:', error);
            marcarError();
        }
    }

    function limpiarOpcionesBase() {
        if (!targetSelectElement) return;
        
        const firstOption = targetSelectElement.options.length > 0 ? targetSelectElement.options[0].cloneNode(true) : null;
        targetSelectElement.innerHTML = '';
        
        if (firstOption) {
            firstOption.textContent = 'A la espera de ciudad...';
            targetSelectElement.appendChild(firstOption);
        }
    }

    function marcarCargando() {
        if (!targetSelectElement) return;
        const firstOption = targetSelectElement.options.length > 0 ? targetSelectElement.options[0].cloneNode(true) : null;
        targetSelectElement.innerHTML = '';
        if (firstOption) {
            firstOption.textContent = 'Buscando oficinas...';
            targetSelectElement.appendChild(firstOption);
        }
    }

    function marcarError() {
        if (!targetSelectElement) return;
        const firstOption = targetSelectElement.options.length > 0 ? targetSelectElement.options[0].cloneNode(true) : null;
        targetSelectElement.innerHTML = '';
        if (firstOption) {
            firstOption.textContent = 'Error al buscar oficinas';
            targetSelectElement.appendChild(firstOption);
        }
    }

    function renderSedesDropdown(sedes) {
        if (!targetSelectElement) return;

        targetSelectElement.innerHTML = '';

        const placeholderOption = document.createElement('option');
        placeholderOption.value = "";
        placeholderOption.className = "rsi-select-placeholder";
        
        const agency = getSelectedAgency();
        const placeholderText = agency === 'olva' ? "Selecciona una oficina Olva" : "Selecciona una oficina Shalom";
        
        if (!Array.isArray(sedes) || sedes.length === 0) {
            placeholderOption.textContent = "No hay oficinas disponibles aquí";
            targetSelectElement.appendChild(placeholderOption);
        } else {
            placeholderOption.textContent = placeholderText;
            targetSelectElement.appendChild(placeholderOption);

            sedes.forEach(sede => {
                const cleanText = (txt) => {
                    return txt.replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ').trim();
                };
                
                const toTitleCase = (str) => {
                    return str.toLowerCase().replace(/(?:^|[\s,.-])\w/g, function(match) {
                        return match.toUpperCase();
                    });
                };

                const nombre = cleanText(sede.nombre || '').toUpperCase();
                const direccionRaw = cleanText(sede.direccion || '');
                const direccion = toTitleCase(direccionRaw);
                
                const optionString = nombre ? `${nombre} — ${direccion}` : direccion;

                const option = document.createElement('option');
                option.value = optionString;
                option.className = "rsi-select-option"; // Clase que usa Releasit
                option.innerHTML = optionString; 

                targetSelectElement.appendChild(option);
            });
        }

        const nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLSelectElement.prototype, "value").set;
        if (nativeInputValueSetter) {
            nativeInputValueSetter.call(targetSelectElement, "");
        }
        
        targetSelectElement.dispatchEvent(new Event('change', { bubbles: true }));
    }

    const observer = new MutationObserver(() => {
        findElements();
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    window.addEventListener('releasit_checkout_started', () => {
        setTimeout(findElements, 500);
    });

    // Lado seguro inicial
    findElements();
});
